type CallToActions = {
  publicModule: boolean
  purchased: boolean
  redirectLink: string
}

type ModuleLinkProps = {
  isPurchased?: boolean
  isPublicModule?: boolean
  productHotLink?: string
  internalSalesPageUrl?: string | null
  moduleUrl: string
}

export const callToActionsModule = ({ purchased, publicModule, redirectLink }: CallToActions) => {
  if (purchased) {
    return [
      {
        to: redirectLink,
        label: 'home.card_cta.access',
        type: 'primary'
      }
    ]
  }

  if (publicModule) {
    return [
      {
        to: redirectLink,
        label: 'home.card_cta.access_for_free',
        type: 'primary'
      }
    ]
  }

  return [
    {
      to: redirectLink,
      label: 'home.card_cta.to_know',
      type: 'success'
    }
  ]
}

export const getModuleLink = ({
  isPurchased = false,
  isPublicModule = false,
  moduleUrl,
  internalSalesPageUrl = null,
  productHotLink = ''
}: ModuleLinkProps): string => {
  if (isPurchased || isPublicModule) {
    return moduleUrl
  }

  if (internalSalesPageUrl) {
    return internalSalesPageUrl
  }

  return productHotLink
}
